import React, { useContext } from 'react'
import { EPCRContext } from '../../EPCR'
import EPCRCard from '../../../../../components/Cards/EPCRCard'
import { Alert, Stack, Typography } from '@mui/material'
import WasItHS from './WasItHS'
import HSDetails from './HSDetails'
import HSType from './HSType'
import HSActions from './HSActions'
import HSOrgNotified from './HSOrgNotified'
import HSAdditionalNotes from './HSAdditionalNotes'

const HealthSafety = () => {
  const { formValues } = useContext(EPCRContext)

  if (formValues?.incident?.incidentType === 'Event')
    return (
      <EPCRCard>
        <Typography variant="title3">Health and Safety</Typography>
        <WasItHS />
        <Alert severity="info">
          Record Health & Safety Incidents related to the Event. Incidents here
          will be reported back to the Event Organiser. Record Internal
          Organisation incidents using the Incident Report Form.
        </Alert>
        {formValues?.incident?.healthSafetyConcern && (
          <Stack gap={2}>
            <HSDetails />
            <HSType />
            <HSActions />
            <HSOrgNotified />
            <HSAdditionalNotes />
          </Stack>
        )}
      </EPCRCard>
    )
}

export default HealthSafety
